import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const GastroenterologyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.6426 40C79.6426 61.8153 61.9578 79.5 40.1426 79.5C18.3273 79.5 0.642578 61.8153 0.642578 40C0.642578 18.1848 18.3273 0.5 40.1426 0.5C61.9578 0.5 79.6426 18.1848 79.6426 40Z'
    />
    <path
      d='M46.1328 24.2392C52.0615 23.9238 59.2383 26.4512 59.2383 37.3115C59.2383 43.9697 57.4785 50.4209 53.2793 54.6211C49.6426 58.2578 44.9209 59.4346 40.5811 59.4346C40.2246 59.4346 39.8799 59.4297 39.5449 59.4189L46.1328 24.2392Z'
      fill='#E05C87'
    />
    <path
      d='M39.1016 25.2246C39.9213 25.3891 40.7698 25.3372 41.5635 25.0742C43.0419 24.6003 44.5755 24.3196 46.126 24.2393H46.1328C51.5918 24.5449 57.3447 27.5879 57.3447 37.3115C57.3447 43.9697 55.585 50.4209 51.3857 54.6211C47.9873 58.0195 43.6416 59.2695 39.5449 59.4189C30.4268 59.1523 28.8994 55.376 26.9453 55.376C26.6279 55.3713 26.3191 55.4788 26.0732 55.6797L25.4903 55.6741L23.2148 59.042L21.0469 59.0264V57.498C21.0469 48.5693 25.5742 48.4434 31.6113 48.4434C37.6484 48.4434 40.6426 38.9219 36.2402 34.5205C31.8389 30.1182 29.2637 27.2725 29.2637 20.5654H33.3975L36.3857 24.9362L39.1016 25.2246Z'
      fill='#FF759B'
    />
    <path
      d='M41.1191 42.5517H41.1182C41.1191 42.6005 41.1191 42.6503 41.1191 42.7001C41.1191 48.5243 35.3281 47.7636 35.3281 52.5683C35.3281 54.5224 37.043 56.3954 40.1982 56.3954C41.9004 56.3954 52.748 55.8739 55.2549 42.5614L55.2354 42.5575L48.2771 39.1018L41.1191 42.5517Z'
      fill='#FBE17A'
    />
    <path
      d='M47.626 27.4385C44.4707 27.4385 40.1562 29.5713 40.1562 34.1592C40.1562 36.4697 41.0928 39.0791 41.1182 42.5518H41.1191C44.4912 42.6084 44.5273 45.335 47.9717 45.335C51.5498 45.335 51.4492 42.3916 55.2353 42.5576L55.2549 42.5615C55.612 40.5926 55.7849 38.5947 55.7715 36.5937C55.7715 30.2803 51.6397 27.4385 47.626 27.4385Z'
      fill='#D24F75'
    />
    <path
      d='M39.1016 25.2246C36.2715 25.793 33.4834 23.7344 33.3984 20.7637C33.3984 20.748 33.3975 20.6729 33.3975 20.5654H35.2891C35.2891 20.6318 35.29 20.6982 35.292 20.7637C35.3574 23.0586 37.0361 24.8096 39.1016 25.2246Z'
      fill='#E05C87'
    />
    <path
      d='M26.0732 55.6797C25.4834 56.1582 25.1084 57.2266 25.1084 59.0557L23.2148 59.042C23.2178 56.4316 23.9854 55.376 25.0518 55.376C25.3916 55.376 25.7178 55.4902 26.0732 55.6797Z'
      fill='#E05C87'
    />
  </svg>
));
GastroenterologyIcon.displayName = 'GastroenterologyIcon';

export default GastroenterologyIcon;
